import { ICurrency } from './business-plan.constants';
import { apiFunctionsEnum } from './api.constants';

export interface IHouseAccountBalance {
	id: number;
	amount: number;
	currencyId: number;
	currency: ICurrency;
	createdAt: Date;
	updatedAt: Date;
}

export interface IBalanceTypeCategory {
	name: DashboardCategories;
	icon: string;
}

export interface IBalanceDashboard {
	Sum?: number;
	currencyId?: number;
	currency?: ICurrency;
}

export const minimumBalanceAmount = 2000000;

export enum BalanceType {
	Topping = 'Topping Up the Account',
	DigitalTopping = 'Topping Up the Account Digital',
	Withdrawal = 'Withdrawal',
}

type DateRange = {
	startDate?: Date;
	endDate: Date;
};

export interface IFilterType {
	manager?: string;
	lead?: string;
	dealer?: string;
	datesRange: DateRange;
}

export enum BalanceStatus {
	None = 'None',
	Pending = 'Pending',
	PendingBoSignerReview = 'PendingBoSignerReview',
	PendingCCTransfer = 'PendingCCTransfer',
	Completed = 'Completed',
	Rejected = 'Rejected',
	Failed = 'Failed',
	Deleted = 'Deleted',
}

export enum DashboardCategories {
	CONVERSION_FEES = 'conversionFees',
	PAYMENT_FEES = 'paymentFees',
	MONTHLY_SUBSCRIPTIONS = 'monthlySubscriptions',
	MONTHLY_SUBSCRIPTIONS_BY_CUSTOMERS = 'monthlySubscriptionsByCustomers',
	PLAN = 'planFees',
	TOTAL_REVENUE = 'totalRevenue',
	CUSTOMER_BALANCES = 'customerBalances',
	CUSTOMER_BALANCES_DETAIL_BY_CUSTOMERS = 'customerBalancesDetailByCustomers',
	PENDING_BALANCE = 'pendingBalance',
}

export const DashboardCategoriesIconsMapping = {
	[DashboardCategories.CONVERSION_FEES]: 'wallet',
	[DashboardCategories.PAYMENT_FEES]: 'receipt-payment',
	[DashboardCategories.MONTHLY_SUBSCRIPTIONS]: 'wallet',
	[DashboardCategories.MONTHLY_SUBSCRIPTIONS_BY_CUSTOMERS]: 'wallet',
	[DashboardCategories.TOTAL_REVENUE]: 'coins',
	[DashboardCategories.CUSTOMER_BALANCES]: 'balance',
	[DashboardCategories.CUSTOMER_BALANCES_DETAIL_BY_CUSTOMERS]: 'balance',
	[DashboardCategories.PENDING_BALANCE]: 'pending-request',
};

export const DashboardCategoriesFetchDataMapping = {
	[DashboardCategories.CONVERSION_FEES]: apiFunctionsEnum.GET_CONVERSION_FEES,
	[DashboardCategories.PAYMENT_FEES]: apiFunctionsEnum.GET_PAYMENT_FEES,
	//[DashboardCategories.MONTHLY_SUBSCRIPTIONS] : 'receipt-commission',
	[DashboardCategories.TOTAL_REVENUE]: apiFunctionsEnum.GET_TOTAL_REVENUE_BY_COMPANY,
	[DashboardCategories.CUSTOMER_BALANCES]: apiFunctionsEnum.GET_ACCOUNT_BALANCE,
	[DashboardCategories.CUSTOMER_BALANCES_DETAIL_BY_CUSTOMERS]: apiFunctionsEnum.GET_ACCOUNT_BALANCE,
	[DashboardCategories.PENDING_BALANCE]: apiFunctionsEnum.GET_PENDING_BALANCE,
	[DashboardCategories.MONTHLY_SUBSCRIPTIONS]: apiFunctionsEnum.GET_PLAN_FEES,
	[DashboardCategories.MONTHLY_SUBSCRIPTIONS_BY_CUSTOMERS]: apiFunctionsEnum.GET_PLAN_FEES_BY_COMPANY,
	//[DashboardCategories.PENDING_BALANCE] : 'pending-request',
};

export const DashboardCategoriesFetchDataDetailsMapping = {
	[DashboardCategories.CONVERSION_FEES]: true,
	[DashboardCategories.PAYMENT_FEES]: true,
	//[DashboardCategories.MONTHLY_SUBSCRIPTIONS] : 'receipt-commission',
	[DashboardCategories.TOTAL_REVENUE]: true,
	[DashboardCategories.CUSTOMER_BALANCES]: false,
	[DashboardCategories.CUSTOMER_BALANCES_DETAIL_BY_CUSTOMERS]: true,
	[DashboardCategories.PENDING_BALANCE]: true,
	[DashboardCategories.MONTHLY_SUBSCRIPTIONS]: true,
	//[DashboardCategories.PENDING_BALANCE] : 'pending-request',
};

export const bottomCategories: IBalanceTypeCategory[] = [
	{ name: DashboardCategories.CONVERSION_FEES, icon: 'wallet' },
	{ name: DashboardCategories.PAYMENT_FEES, icon: 'receipt-payment' },
	{ name: DashboardCategories.MONTHLY_SUBSCRIPTIONS, icon: 'receipt-commission' },
	{ name: DashboardCategories.TOTAL_REVENUE, icon: 'coins' },
];

export const topCategories: IBalanceTypeCategory[] = [
	{ name: DashboardCategories.CUSTOMER_BALANCES, icon: 'balance' },
	{ name: DashboardCategories.PENDING_BALANCE, icon: 'pending-request' },
];

export const currenciesToDisplay = ['ILS', 'EUR', 'GBP', 'USD', 'CHF', 'CNY', 'CAD', 'NOK'];
export enum DashboardCategoriesPropertiesNames {
	'CURRENCY_ID' = 'currencyId',
	'CURRENCY_NAME' = 'currencyName',
	'CURRENCY_CODE' = 'currencyCode',
	'CURRENCY_SYMBOL' = 'currencySymbol',
	'CONVERSION_RATE' = 'conversionRate',
	'CONVERSION_DATE' = 'conversionDate',
	'SUM' = 'sum',
	'SUM_NIS' = 'sumNis',
	'NUMBER_OF_COMPANIES' = 'numberOfCompanies',
	'FEE_SYMBOL' = 'feeSymbol',
	'FEE_IN_SHEKEL' = 'feeInShekel',
}

export enum depositType {
	Digital = 'digital',
	Manual = 'manual',
}
